import React from 'react';
import { colors } from '../constants';

const Calendar = ({ width, color }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height="20"
    viewBox="0 0 20 20"
  >
    <g fill={color} fillRule="nonzero">
      <path d="M2 3.75h16c.966 0 1.75.784 1.75 1.75v12A1.75 1.75 0 0 1 18 19.25H2A1.75 1.75 0 0 1 .25 17.5v-12c0-.966.784-1.75 1.75-1.75zm0 1.5a.25.25 0 0 0-.25.25v12c0 .138.112.25.25.25h16a.25.25 0 0 0 .25-.25v-12a.25.25 0 0 0-.25-.25H2z" />
      <path d="M1.5 9.75h17v-1.5h-17zM14.25 1v3a.75.75 0 1 0 1.5 0V1a.75.75 0 1 0-1.5 0zM4.25 1v3a.75.75 0 0 0 1.5 0V1a.75.75 0 0 0-1.5 0z" />
    </g>
  </svg>
);

Calendar.defaultProps = {
  width: 20,
  color: colors.darkBlue,
};

export default Calendar;
